import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './LineHeight24Icon.c.svg';

export const LineHeight24Icon = withIconWrapper(ReactComponent);
